import { Button, Link, styled, TableCell, TableRow } from "@mui/material";
import { DOMAIN_ONSHIP } from "../../../../../../utils/constants";


export const StyledTableCell = styled(TableCell)(() => ({
    fontSize: 14,
    borderBottom: 'none !important',
}));


export const StyledIconTableCell = styled(TableCell)(() => ({
    fontSize: 14,
    borderBottom: 'none !important',
    display: 'flex',
    alignItems: 'center',
}));

export const StyledLink = styled(Link)(({ userDomain }) => ({
    fontSize: 14,
    color: '#638dff !important',
    ...(userDomain === DOMAIN_ONSHIP && { fontFamily: 'Figtree-Regular' }),
}));

const baseRowStyles = () => ({
    backgroundColor: '#ffffff',
    whiteSpace: 'break-spaces',
    '&:nth-of-type(odd)': {
        // backgroundColor: '#f4f7fb',
    },
});

const offlineRowStyles = {
    backgroundColor: 'transparent',
    '&:nth-of-type(odd)': {
        backgroundColor: "transparent",
    },
};


export const StyledTableRow = styled(TableRow, {
    shouldForwardProp: (prop) => !["isoffline", "isSectionId"].includes(prop),
})((props) => ({
    ...baseRowStyles(props),
    ...(props.isoffline !== "true" && offlineRowStyles),
}));


export const SaveButton = styled(Button)(({ userDomain }) => ({
    textTransform: 'none',
    border: 'none',
    fontSize: '14px',
    padding: '5px 12px',
    borderRadius: 30,
    margin: '0 5px',
    backgroundColor: "#638dff",
    color: '#FFFFFF',
    fontFamily: 'Roboto, sans-serif',
    boxShadow: 'none',
    '&:hover': { backgroundColor: "#4c71d6" },
    '&:focus': { boxShadow: '0 0 6px 0 #638dff !important' },
    '&:disabled': {
        backgroundColor: '#aeb8d6',
        color: '#e8ecf8',
    },
    ...(userDomain === DOMAIN_ONSHIP && { fontFamily: 'Figtree-Regular' }),
}));


export const Divider = styled('div')(() => ({
    backgroundColor: '#c4d8ff',
    width: '2px',
    height: '22px',
    display: 'inline-block',
    margin: '0 3px',
    verticalAlign: 'inherit',
}));
